import { render, staticRenderFns } from "./IconAngleRight.vue?vue&type=template&id=5af0e580&"
import script from "./IconAngleRight.vue?vue&type=script&lang=js&"
export * from "./IconAngleRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports